import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { dateTime } from "@/lib/format";
import { SelectBox } from "@/components/common/ui";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ENTITIES = ["lead", "user", "role", "workflow", "quotation", "task", "setting", "market", "export", "demo"];

export default function AuditTab() {
  const [entity, setEntity] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/audit", { params: { entity: entity || undefined, limit: 300 } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [entity]);
  return (
    <div>
      <div className="mb-3"><SelectBox value={entity} onChange={setEntity} testid="audit-entity-filter" allLabel="All entities" options={ENTITIES.map((e) => ({ value: e, label: e }))} /></div>
      <div className="bg-white border rounded-md overflow-x-auto" data-testid="audit-table">
        <Table>
          <TableHeader><TableRow><TableHead>When</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell className="text-xs whitespace-nowrap">{dateTime(r.created_at)}</TableCell>
                <TableCell className="text-sm">{r.user_name}</TableCell>
                <TableCell className="num text-xs">{r.action}</TableCell>
                <TableCell className="text-xs">{r.entity}</TableCell>
                <TableCell className="text-[11px] text-slate-500 max-w-md truncate" title={JSON.stringify(r.details)}>{JSON.stringify(r.details)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
